import URLParser from '../URLParser'

const afterPathnameKey = (traffic, key) => {
  const urlObject = new URLParser(traffic.url)
  const pathnameParts = urlObject.pathname.split('/')
  return pathnameParts[pathnameParts.indexOf(key) + 1]
}

export default afterPathnameKey



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/selectors/afterPathnameKey.js